import { Component, Input, OnInit } from '@angular/core';
import { ActivitiesService } from '../../../../services/activities.service';
import { Globals } from 'projects/core/src/globals';
import { ToastMode } from 'projects/core/src/include/structures';
import { AddressComponent } from '../../../address/address.component';

@Component({
  selector: 'app-confirm-missing-values',
  templateUrl: './confirm-missing-values.component.html',
  styleUrls: ['./confirm-missing-values.component.css']
})
export class ConfirmMissingValuesComponent implements OnInit {

  @Input()
  list:any=[];

  @Input()
  item:any={};

  constructor(
    private activitiesService:ActivitiesService
  ) { }

  ngOnInit(): void {
    for(let i=0;i<this.list.length;i++){
      this.list[i].enable=true;
    }
  }

  ngOnChanges(): void {
    
  }

  confirm(){
    this.activitiesService.updateMissingValues(this.list).subscribe((result)=>{
      Globals.message.showToaster("Valori aggiornati nel database",ToastMode.SUCCESS);
      this.close();   
    });
    
  }

  close(){
    this['modalWindow'].close();
  }

  getFieldName(field){
    return "missingValues_"+field;
  }

  selectAddress(field:any){
      var id_type=0;
      
      if(field)
  
      {
          if(!Array.isArray(field.params)){
            try{
              field.params=JSON.parse(field.params);
            }catch{
              field.params=[];
            }
          }
          
          if(Array.isArray(field.params)){
            for(let p of field.params){
              if(p.name=="id_type")
                id_type=parseInt(p.value);
            }
          }
      } 
      
      Globals.modal.showModal(AddressComponent,[
        {"name":"mode","value":"modal"},
        {"name":"resetState","value":true},
        {"name":"id_type","value":id_type},
        
      ],(instance:any)=>{
        if(instance!=null){
          field.value={"name":instance['recordSelected'].name,"id":instance['recordSelected'].id};
        }
      })
      
    }

}
